import React, { useEffect, useRef, useState } from "react";
import {
  Stack,
  TextField,
  Typography,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Modal,
  Fade,
  Box,
  Grid,
  Radio,
  Autocomplete,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import uploadStyles from "./SegmentUploadDocument.module.scss";
import icon from "../../../Components/assets/Images/iconnew.svg";
import SnackBar from "../../../Components/SnackBars/SnackBar";
import SucessSnackBar from "../../../Components/SnackBars/SucesssnackBar";
import BackDrop from "../../../Components/BackDrop";
import ErrorSnackBar from "../../../Components/SnackBars/ErrorSnackBar";
import {
  AAFetchStatementAPICall,
  GetIncomeProofAPICall,
  SegmentCompleteUploadAPICall,
  SegmentStageDetailsAPICall,
  SegmentUploadDropdownAPICall,
} from "../SegmentUpdateAPICalls";
import keyboardicon from "../../../Components/assets/Images/uploadicongrey.svg";
import FormatterCheckerSegment from "./SegmentFormatchecker";
import uploadwhiteicon from "../../../Components/assets/Images/uploadwhiteicon.svg";
import uploadblueicon from "../../../Components/assets/Images/uploadblueicon.svg";
import incomeicon from "../../../Components/assets/Images/incomeicon.svg";
import repeat from "../../../Components/assets/Images/repeat.svg";
import repeatblue from "../../../Components/assets/Images/repeaticonblue.svg";
import { isMobile } from "react-device-detect";
import { REDIRECTURL } from "../../../shared/constants";

export default function SegmentUploadDocumentsPage() {
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [message, setmessage] = React.useState("");
  const [infoMessage, setinfoMessage] = React.useState(false);
  const [incomeProofDropdown, setincomeProofDropdown] = useState<any>([]);
  const [incomeProofDocRef, setincomeProofDocRef] = useState<any>();
  const [signatureDocRef, setSignatureDocRef] = useState<any>();
  const [panCardDocRef, setPanCardDocRef] = useState<any>();
  const [showUpload, setShowUpload] = useState(false);

  const [disableContinueOption3, setdisableContinueOption3] = useState("");

  const [displayDropdownOptions, setDisplayDropdownOptions] = useState(true);
  const [completedStages, setCompletedStages] = useState<any>();
  const [incomeProofUrl, setincomeProofUrl] = useState<any>();
  const [signatureUrl, setsignatureUrl] = useState<any>();
  const [bankProofeUrl, setbankProofUrl] = useState<any>();
  const [pancardUrl, setpancardUrl] = useState<any>();
  const [IncomeProof, setIncomeProof] = useState<any>("");
  const [InformationMessage, setInformationMessage] = useState("");
  const [backdrop, setBackDrop] = useState(false);
  const rupeeSymbol = String.fromCharCode(8377);
  const [uploadmessage, setUploadmessage] = useState("");
  const [backLoading, setBackDropLoading] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [IncomeProofDocTypeRef, setIncomeProofDocTypeRef] = useState("");
  const [bankDetails, setBankDetails] = useState({
    AccountNumber: "",
    IFSCCode: "",
  });

  const [initialdropdowndata, setinitialdropdowndata] = useState<any>([]);
  const [childWindowRef, setchildWindowRef] = useState<any>(null);
  const [closetTimer, setclosetTimer] = useState(false);
  const timerRef = useRef<any>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [selectedFileIncomeProof, setSelectedFileIncomeProof] =
    useState<File | null>(null);
  const [fetchLodaing, setFetchLoading] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");
  const segmentRequestid: any = sessionStorage.getItem("segmentRequestid");
  const [fetchIncomeLoading, setFetchIncomeLoading] = useState(false);
  const [bgColor1, setbgcolor1] = useState("#006779");
  const [bgColor2, setbgcolor2] = useState("#E1E2E3");
  const [selectedValue, setSelectedValue] = useState("a");
  const requestID: any = sessionStorage.getItem("segmentRequestid");

  const chequeFormat = ["png", "jpg", "jpeg"];
  const formats = ["pdf", "png", "jpg", "jpeg"];

  const handleChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
  };

  const handleChange = (event: any) => {
    setIncomeProofDocTypeRef(event.target.value.docTypeRef);
    //  console.log(event.target.value.docTypeRef);

    setIncomeProof(event.target.value);
    setincomeProofDocRef(event.target.value.document_type_reference);

    setShowUpload(true);

    switch (event.target.value.value) {
      case "Copy of ITR acknowledgement":
        setInformationMessage(
          `ITR acknowledgment with gross annual income exceeding ${rupeeSymbol}1,20,000`,
        );
        break;
      case "Salary Slip for last 3 months":
        setInformationMessage(
          `The latest salary slip with gross monthly income exceeding ${rupeeSymbol}15,000`,
        );
        break;
      case "Copy of Form 16 in case of salary income":
        setInformationMessage(
          `Form 16 with gross annual income exceeding ${rupeeSymbol}1,20,000`,
        );
        break;
      case "Copy of cancelled cheque":
        setInformationMessage(`Copy of cancelled cheque of your bank account`);
        break;
      case "Bank account statement for last 6 month":
        setInformationMessage(
          `Bank statement for the last 6 months with average balance of more than ${rupeeSymbol}10,000`,
        );
        break;
    }
  };
  const handleClick = () => {
    let obj: any = {
      request_id: segmentRequestid,
    };
    SegmentCompleteUploadAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // console.log("responseData",responseData)
        navigate(`/segmentUpdate/${responseData.data.next_stage}`);
      })
      .catch((error: any) => {
        setloading(false);
      });
  };

  const handleStageAPI = () => {
    setloading(true);
  };

  const handlePreview = (data: any) => {
    //console.log(data);
  };
  const handleDisplayOptions = (data: any) => {
    setDisplayDropdownOptions(data);
    if (data === true) {
      setIncomeProof("");
      setIncomeProof(initialdropdowndata[0]);

      setincomeProofDocRef(initialdropdowndata[0].document_type_reference);
      // setShowUpload(false);
      setincomeProofUrl("");
      setInformationMessage("");
    }
  };
  useEffect(() => {
    if (!closetTimer && childWindowRef) {
      //  console.log("timer trigger");
      timerRef.current = setInterval(checkChild, 500);
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [childWindowRef, closetTimer]);

  function checkChild() {
    // console.log("timer");

    if (childWindowRef && childWindowRef.closed) {
      clearInterval(timerRef.current);
      setFetchIncomeLoading(false);
      StageDetailsInitial();
      setFetchLoading(false);
    }
  }

  const handleOpenClickIncomeProof = () => {
    setFetchIncomeLoading(true);
    let digilink: string = "";

    let obj: any = {
      request_id: segmentRequestid,
      callback_url: `${REDIRECTURL}segmentUpdate/account_aggregator`,
    };

    AAFetchStatementAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;

        digilink = responseData.data.link;

        window.location.href = digilink;
      })
      .catch((error: any) => {
        setFetchIncomeLoading(false);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    StageDetailsInitial();
  }, []);

  const StageDetailsInitial = () => {
    let dropDowndata: any;
    setBackDropLoading(true);
    let objSegment: any = {
      doc_type: "document_type",
    };
    GetIncomeProofAPICall(objSegment)
      .then((response: any) => {
        const responseData = response.data;

        const incomeProofdata = responseData.data.income_proof;
        const filtredData = incomeProofdata.sort(
          (a: any, b: any) => a.sequence - b.sequence,
        );
        // console.log("responseData", filtredData[0].docTypeRef);
        setIncomeProof(filtredData[0]);
        setinitialdropdowndata(filtredData);
        setIncomeProofDocTypeRef(filtredData[0].document_type_reference);
        setincomeProofDocRef(filtredData[0].document_type_reference);
        setShowUpload(true);
        setincomeProofDropdown(filtredData);
        dropDowndata = responseData.data.income_proof;
      })
      .catch((error: any) => {});
    let obj: any = {
      request_id: requestID,
      stage: "upload_documents",
    };

    SegmentStageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // console.log("uploadstage", responseData.data);
        if (response.data.data.ErrMessage) {
          setRejectMessage(response.data.data.ErrMessage);
        }
        if (response.data.data.request_id) {
          sessionStorage.setItem(
            "segmentRequestid",
            response.data.data.request_id,
          );
        }

        setBackDropLoading(false);

        if (responseData.data.data.url && responseData.data.data.url !== "") {
          setdisableContinueOption3("Successfully uploaded the document.");
        }

        if (responseData.data.data.url && responseData.data.data.url !== "") {
          setShowUpload(true);
          setDisplayDropdownOptions(false);
          setincomeProofUrl(responseData.data.data.url);
          setSelectedValue("b");
        }

        if (dropDowndata && responseData.data.data.doc_type_ref) {
          const SetSelectData = dropDowndata.find(
            (item) =>
              item.document_type_reference ===
              responseData.data.data.doc_type_ref,
          );

          setIncomeProof(SetSelectData);
          setincomeProofDocRef(responseData.data.data.doc_type_ref);
          setDisplayDropdownOptions(false);
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
        setBackDropLoading(false);
      });
  };

  const dataArray: any[] = [];

  const handleDocumentID = (data: any) => {
    setdisableContinueOption3(data);

    setUploadmessage(data);

    setTimeout(() => {
      setUploadmessage("");
    }, 5000);
  };

  return (
    <div className={uploadStyles.mainWrapperTop}>
      <ErrorSnackBar message={rejectMessage} />
      <SucessSnackBar message={uploadmessage} />

      <SnackBar message={message} />

      <div className={uploadStyles.wrapper}>
        <div className={uploadStyles.step}>
          <img src={keyboardicon} /> Step 3 of 4
        </div>
        <div className={uploadStyles.headerSection}>
          <p className={uploadStyles.signup}>Upload Your Documents</p>
          <div className={uploadStyles.subText}>
            Since you selected F & O Income Proof is Mandate
          </div>
        </div>
        {!backLoading ? (
          <>
            <div className={uploadStyles.uploadSection}>
              <FormControl>
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: "0px 3px",
                    gap: "5px",
                    fontSize: { xs: "14px", sm: "17px" },
                    color: "var(--Red-Black-Black-900, #111827)",
                    marginTop: { xs: "-12px", sm: "0px" },
                    maxWidth: "unset",
                    width: "max-content",
                  }}
                >
                  <img src={incomeicon} style={{ width: "20px" }} /> Income
                  Proof
                </InputLabel>

                <Select
                  //  style={{ width: "300px", margin: "25px !important" }}
                  className={uploadStyles.uploadSectionSelectDropDown}
                  disableUnderline
                  sx={{
                    boxShadow: "none",
                    ".MuiOutlinedInput-notchedOutline": { border: 0 },
                    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                      {
                        border: 0,
                      },
                    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        border: 0,
                      },
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                    color: "#6B7280",
                    fontSize: "14px",
                  }}
                  MenuProps={{
                    MenuListProps: {
                      sx: {
                        "& .MuiPaper-root": {
                          borderRadius: "10px",
                        },

                        "& li.Mui-selected": {
                          background: "#1F2937",
                          color: "white",
                          "&:hover": {
                            background: "#1F2937",
                            color: "white",
                          },
                        },
                      },
                    },
                  }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={IncomeProof}
                  label="Select Proof Type"
                  onChange={handleChange}
                  disabled={displayDropdownOptions === false}
                >
                  {incomeProofDropdown.map((data: any, index: any) => {
                    // console.log(data)
                    return (
                      <MenuItem value={data} key={index}>
                        {data.value}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>

              <div className={uploadStyles.buttonssectionpan}>
                {IncomeProof?.value ===
                  "Bank account statement for last 6 months" &&
                  disableContinueOption3 !==
                    "Successfully uploaded the document." &&
                  !incomeProofUrl && (
                    <LoadingButton
                      variant="contained"
                      component="label"
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column-reverse", sm: "row" },
                        height: { xs: "max-height", sm: "35px" },
                        color: { xs: "#3263E5", sm: "white" },
                        borderRadius: "20px",
                        boxShadow: "none",
                        fontSize: "12px",
                        background: { xs: "white", sm: "#3263E5" },
                        "&:hover": {
                          background: { xs: "white", sm: "#3263E5" },
                        },
                      }}
                      onClick={handleOpenClickIncomeProof}
                      loading={fetchIncomeLoading}
                    >
                      <span style={{ width: "max-content" }}>
                        Verify Online
                      </span>{" "}
                      <img
                        src={isMobile ? repeatblue : repeat}
                        width={"20px"}
                      />
                    </LoadingButton>
                  )}
                {IncomeProof?.value ===
                  "Bank account statement for last 6 months" &&
                  disableContinueOption3 !==
                    "Successfully uploaded the document." &&
                  !incomeProofUrl && (
                    <span style={{ fontSize: "19px", color: "#E5E7EB" }}>
                      |
                    </span>
                  )}

                <>
                  {" "}
                  {showUpload ? (
                    <FormatterCheckerSegment
                      previewImage={handlePreview}
                      acceptedFormats={formats}
                      documentRef={"income_proof"}
                      documentID={handleDocumentID}
                      displayOptions={handleDisplayOptions}
                      stageDetailsData={incomeProofUrl}
                      name="incomeproof"
                      purpose={incomeProofDocRef}
                      pdfSize={7.5}
                      imageSize={7.5}
                    />
                  ) : (
                    <LoadingButton
                      variant="contained"
                      component="label"
                      disabled
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column-reverse", sm: "row" },
                        height: { xs: "max-height", sm: "35px" },
                        color: { xs: "#3263E5", sm: "white" },
                        borderRadius: "20px",
                        boxShadow: "none",
                        fontSize: "12px",
                        background: { xs: "white", sm: "#3263E5" },
                        "&:hover": {
                          background: { xs: "white", sm: "#3263E5" },
                        },
                      }}
                    >
                      <span>Upload</span>{" "}
                      <img
                        src={isMobile ? uploadblueicon : uploadwhiteicon}
                        width={"20px"}
                      />
                    </LoadingButton>
                  )}{" "}
                </>
              </div>
            </div>

            <div className={uploadStyles.buttonStack}>
              {disableContinueOption3 ===
              "Successfully uploaded the document." ? (
                <LoadingButton
                  variant="contained"
                  onClick={handleClick}
                  loading={loading}
                  id="upLoadDocumentsContinueButton"
                  className={uploadStyles.approveButton}
                  sx={{ height: "50px" }}
                >
                  {" "}
                  Continue
                </LoadingButton>
              ) : (
                <LoadingButton
                  variant="contained"
                  onClick={handleClick}
                  loading={loading}
                  disabled
                  id="upLoadDocumentsContinueButton"
                  className={uploadStyles.approveButton}
                  sx={{ height: "50px" }}
                >
                  {" "}
                  Continue
                </LoadingButton>
              )}
            </div>
          </>
        ) : (
          <div style={{ height: "65vh" }}>
            <BackDrop />
          </div>
        )}
      </div>
    </div>
  );
}
